export const groupRoleListSelectors = {
	isFetching: (state) => state.groupRoles.isFetching,
	isRefresh: (state) => state.groupRoles.isRefresh,
	error: (state) => state.groupRoles.error,
	content: (state) => state.groupRoles.content,
	roles: (state) => state.groupRoles.content.roles,
};
